import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { QueryState } from '@/components/feedback/query-state';
import { SkeletonSheet } from '@/components/feedback/skeletons';
import { PartnerDetail } from '@/components/partners/partner-detail';
import { Alert } from '@/components/ui/alert';
import { adminQuery } from '@/lib/query';

export const Route = createFileRoute('/_app/partners/$partnerId')({
  component: PartnerPage,
});

/** One partner on its own page. */
function PartnerPage() {
  const { partnerId } = Route.useParams();
  // Credentials' last use and the call count change without the staff member
  // doing anything, so the page reads again now and then.
  const partners = useQuery({
    ...adminQuery('partners.list', {}),
    refetchInterval: 30_000,
  });
  return (
    <QueryState
      query={partners}
      label="this partner"
      skeleton={<SkeletonSheet />}
    >
      {(data) => {
        const partner = data.rows.find((item) => item.id === partnerId);
        if (!partner) return <Alert>No such partner.</Alert>;
        return <PartnerDetail partner={partner} />;
      }}
    </QueryState>
  );
}
